import $ from 'jquery';
import { register } from '../../core/bootstrapper';
import BusinessSpecificFormModel from '../../layout/b2b/businessSpecificFormModel';
import RegisterFormPrivateCustomerView from '../../pages/login/registerFormPrivateCustomerView';
import PasswordQualityView from '../../layout/PasswordQualityView';
import PhoneNumberFormatter from '../../layout/phoneNumberFormatterView';
import RemoteEmailValidation from '../../layout/remoteEmailValidation';
import LoginView from '../../pages/login/loginView';
import RegisterFormBusinessCustomerView from '../../pages/login/registerFormBusinessCustomerView';
import RegisterFormModel from '../../pages/login/registerFormModel';
import RegisterFormViewModel from '../../pages/login/registerFormViewModel';

register('login', () => {
  var $loginPage = $('#checkout-login');
  var $blockFull = $loginPage.find('#checkout-registration-block-full');
  var viewModel = new RegisterFormViewModel({
    form: new RegisterFormModel(),
    businessForm: new BusinessSpecificFormModel()
  });
  var form = viewModel.get('form');

  function getAccountType(model) {
    return model.attributes.accountType === 'business' ? 'business' : 'private';
  }

  function getField(model, name) {
    return $blockFull.find(
      `.js-register-form-${getAccountType(model)} input[name="${name}"]`
    );
  }

  function checkField($field, name, validate) {
    /*
     * Handle autocomplete - browser build-in autocomplete doesn't trigger
     * value change event or update backbone data model.
     * Here we're handling two cases of autocomplete:
     * 1. `change:accountType` event which is triggered on view initialize:
     * we are checking if backbone model is not up-to-date with field value.
     * 2. Autocomplete when we're focusing email/password field and browser
     * show a popup to execute autocomplete - then we're manually executing
     * validation on another autofilled field.
     */
    if ($field.val().length > 0) {
      if (!form.get(name)) {
        validate = true;
        form.set(name, $field.val());
      }
      validate && $field.valid();
    }
  }

  function ensureValidator($field) {
    var isRuleAdded = 'error.remote' in $field.rules();

    // If you try to add these rules directly you face with weird bugs on business form.
    // Life is too short
    if (!isRuleAdded) {
      new RemoteEmailValidation({ el: $field });
    }
  }

  function onFormSwitch(model) {
    const $email = getField(model, 'email');

    ensureValidator($email);

    checkField($email, 'email', true);
    checkField(getField(model, 'password'), 'password', true);
  }

  function onCredentialsChange(model) {
    checkField(getField(model, 'email'), 'email');
    checkField(getField(model, 'password'), 'password');
  }

  form.on('change:accountType', onFormSwitch, this);
  form.on('change:email', onCredentialsChange, this);
  form.on('change:password', onCredentialsChange, this);

  new LoginView({
    el: $loginPage
  });

  $blockFull.find('form').each(function() {
    new PasswordQualityView({
      el: this
    });
  });

  $blockFull.find('[name="telephone"]').each(function() {
    new PhoneNumberFormatter({
      el: this
    });
  });

  if ($blockFull.hasClass('js-registration-b2b')) {
    new RegisterFormBusinessCustomerView({
      el: $blockFull,
      model: viewModel
    });
  } else {
    new RegisterFormPrivateCustomerView({
      el: $blockFull,
      model: viewModel
    });
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/login/loginBootstrap.js
 **/